<template>
  <div>
    <div v-if="status == 0" class="sta-main">
        <img :src="cdnUrl.cdnUrl + 'Fr23uoHKjiB7Qkl23ZZ7MyJ1imlp'" alt="">
        <p>该内容已下架</p>
    </div>
    <div v-else>
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="#0C68A9">
            <van-swipe-item v-for="(item,index) in polyDetail.img" :key="index" >
                <van-image class="slider-img" :src="cdnUrl.cdnUrl + item" />
            </van-swipe-item>
        </van-swipe>
        <div class="poly-tip">
            <span class="iconfont icon-a-bianzu18 icon-col"></span>
            <span>{{ polyDetail.title }}</span>
        </div>
        <div class="desc-main">
            <!-- van-multi-ellipsis--l2 -->
            <div @click="isLength=false" class="poly-content " :class="isLength?'more_text':''" v-html="isLength?content:polyDetail.desc"></div>
            <div v-show="!isLength  && showText" @click="isLength=true" class="click-more">收起更多<span class="more-icon iconfont icon-a-bianzu19 icon-col"></span></div>
        </div>
        <ul class="poly-clss-more">
            <li class="poly-class" @click="showWhole()">
                <p>
                    <span class="one">全部</span>
                </p>
            </li>
            <li class="poly-class" @click="showClass(proList)">
                <p>
                    <span class="van-ellipsis">{{ className }}</span>
                    <span class="iconfont icon-zhankai-01 class-icon-col poly-class-icon"></span>
                </p>
            </li>
            <!-- <li class="poly-class" v-for="item in proList" :key="item.id" @click="showClass(item.children)">
                <p>
                    <span class="van-ellipsis">{{ item.title }}</span>
                    <span class="iconfont icon-zhankai-01 class-icon-col poly-class-icon"></span>
                </p>
            </li> -->
        </ul>
        <!-- pdf -->
        <ul class="poly-pdf">
            <li v-for="ite in pdfList" :key="ite.id">
                <div class="poly-pdf-item" v-for="item in ite" :key="item.id" @click="gotoPdf(item)">
                    <div class="poly-pdf-con">
                        <div class="poly-pdf-img">
                            <van-image class="pdf-column-img" src="https://cdn.juplus.cn/FpZLVFiI3F_xTiGu_iKgLBJ4dDBc" />
                            <van-image class="slider-img" :src="cdnUrl.cdnUrl + item.cover" />
                        </div>
                    </div>
                    <p class="van-multi-ellipsis--l3 m-t-p-4">{{ item.title }}</p>
                </div>
            </li>
        </ul>
        <!-- 下载 -->
        <div class="btn-main">
            <p>点击可查看感兴趣的文档，如需一键获取多个文档</p>
            <p class="m-b-10">可点击下方按钮进行勾选</p>
            <div class="down-btn" @click="handleDown">
                点击按钮可批量下载文件
            </div>
        </div>
    </div>
    
     <!-- 表单 -->
    <customer-form ref="customerForm" :formItem="applyFormItem" :formDataList="applyFormDataList" @handleSon="handleSon" :showACode="1"></customer-form>
    <van-popup
      v-model="showBottom"
      position="bottom"
      :style="{ height: '40%' }"
      class="vant-boottom"
    >
      <!-- <van-picker :columns="columns" value-key="title" title="" @change="onChange" show-toolbar
        @cancel="showBottozzzzzzzm = false" @confirm="onConfirm"/> -->
        <van-checkbox-group v-model="newCid" direction="horizontal" style="padding: 0 12px;padding-top: 53px;" ref="checkboxGroup" @change="onChange($event)">
            <van-checkbox v-for="item in columns" :key="item.id" :name="item.id" checked-color="#5BC4DC">{{ item.title }}</van-checkbox>
        </van-checkbox-group>
        <div class="main-btn">
            <button class="send-container btn-cal" @click.stop="showBottom = false">取消</button>
            <button class="send-container" @click.stop="handleSure">确定</button>
        </div>
    </van-popup>
    <down-tip ref="showDownTip"></down-tip>
  </div>
  
</template>

<script>
import { getOS } from '@/libs/util';
import { getpolyDetail,getpolyPdf,getpolyClass,statData,getForm } from '@/api/polymerize';
import customerForm from '@/views/polymerize/components/customer-form';
import { wxShare } from '@/libs/wxjssdk';
import downTip from './components/downTip';
export default {
    components: { customerForm,downTip },
    data () {
        return {
            cdnUrl: this.$config.baseUrl,
            id: '', // 聚合页id
            isLength: false, // 控制描述显示
            showBottom: false,
            columns: ['分类一','分类一','分类一'],
            polyDetail: {},
            pdfList: [],
            proList: [], // 产品的分类
            applyFormDataList: [], // 表单列表
            applyFormItem: {},
            user_exists: false, // 是否填写过 true -- 填写过 false -- 未填写
            isModel: 0, // 设备型号  1  ios  2  Android
            showText: false,
            className: '分类',
            newCid: [],
            status: 1
        }
    },
    mounted () {
        this.id = this.$route.query.id
        this.browserUserId = this.$route.query.uid
        
        this.isModel = getOS()
        this.getDetail()
        this.getPdfList()
        this.getClassList()
        this.recordData()
        let userId = this.$store.state.user.id ? this.$store.state.user.id : this.$route.query.uid
        this.$nextTick(() => {
            history.replaceState(null, null, window.location.origin + `/eppendorf_single/index.html#/polyDetail?id=${this.$route.query.id}&uid=${userId}`)
        })
        
    },
    methods: {
        sharePage () {
          const params = {
            title: this.polyDetail.title, // 分享标题
            desc: this.polyDetail.desc, // 分享描述
            link: `${window.location.href.split('#')[0]}#/polyDetail?id=${this.polyDetail.id}`, // 分享链接
          }
          wxShare(params)
        },
        handleSon() {
            this.getDetail()
        },
        getDetail() { // 聚合详情
            getpolyDetail({id: this.id,uid: this.$store.state.user.id || this.browserUserId}).then(res => {
                res.data.img = JSON.parse(res.data.img)
                this.status = res.data.status
                this.polyDetail = res.data
                this.user_exists = res.data.user_exists
                this.content = this.richTextFormat(this.polyDetail.desc)
                if (res.data.form_id) {
                    this.getFormInfo() // 表单
                }
                this.sharePage()
            })
        },
        recordData() { // 统计人数次数
            let para = {
                type: 1,
                action: 1,
                type_id: this.id,
                uid: this.$store.state.user.id ? this.$store.state.user.id : this.$route.query.uid
            }
            statData(para).then(res=>{})
        },
        getPdfList(category) { // pdf列表
            let para = {
                group_id: this.id,
                cid: category || []
            }
            getpolyPdf(para).then(res => {
                this.pdfList = res.data
            })
        },
        getClassList() { // 分类列表
            getpolyClass({group_id: this.id}).then(res => {
                this.proList = res.data
            })
        },
        gotoPdf(item) {
            window.location.href = `${this.cdnUrl.pro}/pageTurnings/index.html?id=${item.id}&d=${this.id}&productType=4`
            // if (this.polyDetail.form_id && !this.user_exists) {
            //     this.addPhoneCode()
            //     this.$refs.customerForm.showApplyForm()
            // } else {
                
            // }
        },
        getFormInfo() {
            getForm({id: this.polyDetail.form_id}).then(res => {
                this.applyFormDataList = res.data.keys
                if (this.polyDetail.form_id && !this.user_exists) {
                    this.addPhoneCode()
                    this.$refs.customerForm.showApplyForm()
                }
            })
        },
        addPhoneCode() { // 添加验证码
            this.applyFormDataList.forEach(item => {
                if (item.type === 2) {
                this.applyFormItem[item.field] = []
                } else {
                this.applyFormItem[item.field] = ''
                }
            })
            let moIndex = ''
            this.applyFormDataList.filter((value,index) => {
                if (value.field == 'mobile') {
                moIndex = index
                }
                if(value.field == 'code') {
                moIndex = false
                }
            })
            
            if (moIndex) {
                let moblie = {
                field: 'code',
                required: 1,
                title: '验证码',
                type: 3,
                value: "",
                placeholder: "请输入验证码"
                }
                this.applyFormDataList.splice(moIndex+1, 0, moblie)
            }
        },
        showWhole() {
            this.newCid = []
            this.pdfList = []
            this.getPdfList()
            this.className = '分类'
        },
        showClass(data) {
            this.showBottom = true
            // this.newCid = []
            this.columns = data
            
        },
        onChange(val) { // 二级选择
            if (val.length > 0) {
                this.newCid = val
            }
            console.log('看下',this.newCid);
        },
        handleSure() {
            // this.className = 
            let namelist = []
            const newList = this.columns.filter((item) =>{
                if(this.newCid.includes(item.id)) {
                    namelist.push(item.title)
                }
            });
            if (namelist.length > 0) {
                this.className = namelist.join(',')
            }
            this.getPdfList(this.newCid)
            this.showBottom = false
        },
        onConfirm(data) {   // 二级确定
            this.className = data.title
            this.getPdfList(data.id)
            this.showBottom = false
        },
        handleDown() {
            if (this.isModel == '1') { // ios
                this.$router.push({
                    name: 'classDetail',
                    query:{
                        id: this.id,
                        formId: this.polyDetail.form_id,
                        classId: this.newCid.join(','),
                        className: this.className
                    }
                })
            } else {
                if(this.getisweixing()) {
                    this.$router.push({
                        name: 'polyDetail',
                        query:{
                            id: this.id,
                            uid: this.$store.state.user.id || 0
                        }
                    })
                    this.$refs.showDownTip.showTip()
                }else {
                    this.$router.push({
                        name: 'classDetail',
                        query:{
                            id: this.id,
                            formId: this.polyDetail.form_id,
                            uid: this.$route.query.uid || 0,
                            classId: this.newCid.join(','),
                            className: this.className
                        }
                    })
                }
                
            }
        },
        getisweixing(){
             var wx= window.navigator.userAgent.toLowerCase();
            if (wx.match(/MicroMessenger/i) == 'micromessenger') {
                // console.log('是微信浏览器默认走微信')
                return true; // 是微信端
            } else {
                // console.log('不是微信浏览器绘制原生。');
                return false;
            } 
        },
        //内容超过200个字符显示省略号
        richTextFormat(value) {
            value = value.replace(/<\/?.+?>/g,'')
            value = value.replace(/\s+/g,'')
            // console.log('看下',value.length);
            if (value.length > 40) {
                this.showText = true
                this.isLength = true;
                return value.slice(0, 40) + "...";
            }else{
                this.isLength = false;
                this.showText = false
            }
            return value;
        },
    }
}
</script>

<style lang="scss" scoped>
.sta-main {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: rem(100);
}
    ::v-deep .van-checkbox-group--horizontal {
        
        justify-content: start;
        box-sizing: border-box;
    }
    .vant-boottom {
        padding-bottom: rem(70);
        ::v-deep .van-checkbox {
            display: flex;
            flex-flow: row-reverse;
            justify-content: space-between;
            min-width: 109px;
            padding-bottom: 10px;
            width: 100%;
            border-bottom: 1px solid #ccc;
            margin-bottom: 15px;
        }
    }
    
    
    ::v-deep .van-checkbox--horizontal {
        margin-right: 0;
    }
    .m-t-p-4 {
        margin-top: rem(4);
        padding: 0 rem(3);
    }
    .my-swipe {
        width: 100%;
        height: rem(150);
        .slider-img {
            width: 100%;
            height: 100%;
        }
    }
    .poly-tip {
        display: inline-block;
        margin: 0 rem(14) rem(14) rem(14);
        margin-top: rem(11);
        padding-bottom: rem(4);
        font-size: 17px;
        color: $poly-color;
        border-bottom: 1px solid $poly-color;
        span:nth-child(2) {
            margin-left: rem(7);
            
        }
        .icon-col {
            color: $poly-color;
        }
    }
    .poly-content {
        margin: 0 rem(14) rem(14) rem(14);
    }
    .click-more {
        display: flex;
        justify-content: center;
        align-items: center;
        color: $poly-color;
        .more-icon {
            font-size: rem(8);
            margin-left: 8px;
            transform: rotate(180deg);
        }
    }
    .desc-main {
        
    }
    .more_text{
        pointer-events:none;//父元素不触发点击事件
        line-height: 1.5;
    }
    .more_text::after{ //富文本后面追加伪类元素，更多>
        content: "展开更多";
        background:url('https://cdn.juplus.cn/Fs7oXt9S9Fyq6vcs7X2c-4kaEMYY') no-repeat;
        background-size: rem(14);
        background-position: 100% 55%;
        width:1rem;
        display: inline-block;
        position: relative;
        left:0.2rem;
        color: $poly-color;
        pointer-events:auto;//***********该属性可触发点击事件
    }
    .poly-clss-more {
        display: flex;
        justify-content: start;
        flex-wrap: wrap;
        padding: 0 rem(16);
        .poly-class {
            width: rem(120);
            height: rem(40);
            line-height: rem(40);
            margin-top: rem(16);
            margin-right: rem(8);
            // padding: rem(6) rem(13) rem(11) rem(8);
            background: linear-gradient(135deg, #F6FCFF 0%, #EEF9FF 100%);
            box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.03);
            border-radius: 4px;
            box-sizing: border-box;
            p {
                display: flex;
                justify-content: space-around;
                align-items: center;
            }
        }
        .poly-class:nth-child(3n) {
            margin-right: 0;
        }
        .class-icon-col {
            color: $poly-color;
            // transform: rotate(180deg);
        }
        .poly-class-icon {
            text-align: right;
            transform: rotatex(180deg);
            span {
                font-size: rem(12);
            }
        }
    }
    .poly-pdf {
        display: flex;
        flex-wrap: wrap;
        margin-top: rem(16);
        padding: 0 rem(26) rem(115) rem(26);
        li {
            display: flex;
            margin-top: rem(16);
        }
        .poly-pdf-item {
            width: rem(96);
            margin-right: rem(15);
        }
        .poly-pdf-item:nth-child(3n) {
            margin-right: 0;
        }
        .poly-pdf-con {
            width: rem(96);
            height: rem(126);
            background: rgba(244, 246, 248,0.5);
            box-shadow: 2px 2px 4px 0px rgba(12,104,169,0.1), 2px 2px 4px 0px rgba(168,168,168,0.1);
            box-sizing: border-box;
            border-radius: rem(4);
        }
    
        .poly-pdf-img {
            position: relative;
            padding: rem(8);
            border-radius: 0 rem(4) rem(4) 0;
            box-sizing: border-box;
            .pdf-column-img {
                position: absolute;
            }
        .pdf-badge {
            position: absolute;
            right: 12px;
            display: inline-block;
            width: rem(20);
            height: rem(20);
            line-height: rem(20);
            text-align: center;
            color: #fff;
            background-color: $poly-color;
            border-radius: 50%;
            z-index: 1;
        }
  }
  .poly-active {
    border: 1px solid $poly-color;
  }
  .slid-img-active {
    box-shadow: 2px 2px 4px 0px rgba(12,104,169,0.1), 2px 2px 4px 0px rgba(168,168,168,0.1);
  }
  .slider-img {
    border-radius: rem(4);
  }
  .line-img {
    margin-top: rem(25);
  }
}

.btn-main {
    position: fixed;
    bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding: rem(10) 0;
    background-color: #fff;
    box-shadow: 1px -7px 6px 0px rgba(0,0,0,0.05);
    box-sizing: border-box;
    p {
        font-size: rem(12);
    }
    .m-b-10 {
        margin-bottom: rem(5);
    }
}

.down-btn {
    // position: fixed;
    // left: 50%;
    // bottom: rem(10);
    // transform: translateX(-50%);
    display: inline-block;
    width: 60%;
    height: rem(40);
    line-height: rem(40);
    font-size: 17px;
    text-align: center;
    color: #fff;
    background: $base-color;
    border-radius: rem(10);
}
.main-btn {
    display: flex;
    justify-content: space-around;
    position: fixed;
    bottom: 0;
    width: 100%;
    padding: rem(10) 0;
    background-color: #fff;
    box-shadow: 1px -7px 6px 0px rgba(0,0,0,0.05);
}
.send-container{
    display: block;
    width: rem(114);
    height: rem(39);
    font-size: 13px;
    outline: none;
    border: none;
    background: #6CC5DB;
    color: #FEFEFE;
    border-radius:4px;
}
.btn-cal {
    margin-right: rem(8);
    background-color: #ccc;
}
    
</style>